/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_AupInputs */

const en_landing_footer_aup = /** @type {(inputs: Landing_Footer_AupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceptable Use Policy`)
};

/**
* | output |
* | --- |
* | "Acceptable Use Policy" |
*
* @param {Landing_Footer_AupInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const landing_footer_aup = /** @type {((inputs?: Landing_Footer_AupInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_AupInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_footer_aup(inputs)
});
export { landing_footer_aup as "landing.footer.aup" }